import FixaHelperText from "@coworker/apprestructured/src/shared/wrappers/FixaHelperText/FixaHelperText";
import { useTranslation } from "@coworker/locales";
import { ACCEPTED_FILE_EXTENSIONS_LABEL, MAX_FILE_SIZE_MB } from "../../config";
import { ValidationErrorType } from "./hooks/useValidation";

type ValidationMessageProps = {
  validationId: string;
  type: ValidationErrorType;
};

export const ValidationMessage = ({
  validationId,
  type,
}: ValidationMessageProps) => {
  const { t } = useTranslation();

  let message = "";
  if (type === ValidationErrorType.UnsupportedFileType) {
    message = t("launchMediaUploadUnsupportedFileTypeString", {
      acceptedFileExtensions: ACCEPTED_FILE_EXTENSIONS_LABEL,
    });
  } else if (type === ValidationErrorType.FileTooLarge) {
    message = t("launchMediaUploadFileTooLargeString", {
      maxFileSizeMb: MAX_FILE_SIZE_MB,
    });
  }

  return (
    <FixaHelperText
      data-testid="upload-media-dropzone-validation"
      shouldValidate
    >
      <span id={validationId}>{message}</span>
    </FixaHelperText>
  );
};
